export { r as rubberbandIfOutOfBounds } from '../../dist/maths-b2a210f4.esm.js';
